"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractService2 = _interopRequireDefault(require("../../AbstractService"));

var _AbstractClassException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/AbstractClassException"));

var _AbstractMethodException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/AbstractMethodException"));

var _ServiceSettings = _interopRequireDefault(require("../../ServiceSettings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * This class is used for saving planner configurations to the IKEA VPC service.
 *
 * @abstract
 */
var AbstractVpcService = /*#__PURE__*/function (_AbstractService) {
  _inherits(AbstractVpcService, _AbstractService);

  var _super = _createSuper(AbstractVpcService);

  /**
   * Class constructor.
   */
  function AbstractVpcService() {
    var _this;

    _classCallCheck(this, AbstractVpcService);

    _this = _super.call(this);

    if (_this.constructor === _AbstractService2.default) {
      throw new _AbstractClassException.default();
    }

    return _this;
  }
  /**
   * Saves a planner configuration.
   *
   * @abstract
   * @param {VpcServiceConfig} vpcConfig Service config for VPC.
   * @param {Object} productConfig Product configuration object.
   * @param {Object[]} shoppingList Shopping list.
   * @return {Promise} Promise object.
   */


  _createClass(AbstractVpcService, [{
    key: "saveConfiguration",
    value: function saveConfiguration() {
      throw new _AbstractMethodException.default();
    }
    /**
     * Fetches and returns a planner configuration.
     *
     * @abstract
     * @param {VpcServiceConfig} vpcConfig Service config for VPC.
     * @param {String} productConfigId Product configuration id.
     * @return {Promise} Promise object.
     */

  }, {
    key: "getConfiguration",
    value: function getConfiguration() {
      throw new _AbstractMethodException.default();
    }
    /**
     * Parses configuration sources.
     *
     * @param {String[]} acceptableConfigurationSources Configuraion sources.
     * @return {String[]} Parsed configuration sources.
     */

  }, {
    key: "_parseConfigurationSources",
    value: function _parseConfigurationSources(acceptableConfigurationSources) {
      if (acceptableConfigurationSources && acceptableConfigurationSources.length > 0) {
        return acceptableConfigurationSources.map(function (str) {
          return str.toUpperCase();
        });
      }

      return [_ServiceSettings.default.applicationName.toUpperCase()];
    }
  }]);

  return AbstractVpcService;
}(_AbstractService2.default);

exports.default = AbstractVpcService;